
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[urlKey]/pag",
      function () {
        return require("private-next-pages/[urlKey]/pag.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[urlKey]/pag"])
      });
    }
  